import { List, Pagination } from 'react-admin';
import React from 'react';
import ListActions from './ListActions';
import { shouldShowImportButton } from '../helper';

const ListWithCSVImport = ({ children, ...props }) => {
  const ListPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
  return (
    <List
      {...props}
      pagination={<ListPagination />}
      actions={
        <ListActions
          {...props}
          showImportButton={shouldShowImportButton(props)}
          showBreadcrumbs = {(props.showbreadcrumbs) ? true : false}
          showAddButton = {(props.showaddbutton) ? true : false}
        />
      }
    >
      {children}
    </List>
  );
};

export default ListWithCSVImport;
